// @todo Tweak for manipulating multiple masks.
export function constructMaskId(idx, value, resolutionId) {
  return `${idx}//${value}//${resolutionId}`;
}

// obsolete
export function deconstructMaskId(maskId) {
  if (maskId == null) {
    return [null, null, null];
  }

  return maskId.split('//');
}
